var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1994 60.1875L37.9494 9.5625C37.5135 8.81016 36.7612 8.4375 36.0018 8.4375C35.2424 8.4375 34.483 8.81016 34.0541 9.5625L4.80413 60.1875C3.93928 61.6922 5.02209 63.5625 6.75178 63.5625H65.2518C66.9815 63.5625 68.0643 61.6922 67.1994 60.1875ZM33.7518 29.25C33.7518 28.9406 34.0049 28.6875 34.3143 28.6875H37.6893C37.9987 28.6875 38.2518 28.9406 38.2518 29.25V42.1875C38.2518 42.4969 37.9987 42.75 37.6893 42.75H34.3143C34.0049 42.75 33.7518 42.4969 33.7518 42.1875V29.25ZM36.0018 54C35.1186 53.982 34.2777 53.6185 33.6595 52.9875C33.0412 52.3565 32.695 51.5084 32.695 50.625C32.695 49.7416 33.0412 48.8935 33.6595 48.2625C34.2777 47.6315 35.1186 47.268 36.0018 47.25C36.885 47.268 37.7259 47.6315 38.3441 48.2625C38.9623 48.8935 39.3086 49.7416 39.3086 50.625C39.3086 51.5084 38.9623 52.3565 38.3441 52.9875C37.7259 53.6185 36.885 53.982 36.0018 54Z",
    fill: "#FAAD14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.61d7c5640ee67b30d728a4259585452b.svg";
export { ForwardRef as ReactComponent };